/** @format */

import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../app/hooks';
import DisplayFieldData from '../../../common/custom/DisplayFieldData';
import CircularLoader from '../../../common/loaders/circularLoader';
import { selectApplicant } from '../../applicant/ApplicantSlice';
import {
  AddressModelDto,
  ApplicantViewDto
} from '../../applicant/Models';

export default function ViewPersonalDetails() {
  const selectApplicantData = useAppSelector(selectApplicant);
  const [data, setData] = useState<ApplicantViewDto>();

  useEffect(() => {
    if (selectApplicantData.applicantState.applicant) {
      setData(selectApplicantData.applicantState.applicant);
    }
  }, [selectApplicantData.applicantState.applicant]);
  return (
    <>
      <CircularLoader status={selectApplicantData.applicantState.status} />
      {selectApplicantData.applicantState.status === 'idle' && data && (
        <Grid container spacing={2} mt={-4}>
          <Grid item xs={6}>
            <DisplayFieldData
              header='First Name'
              value={data?.personalDetails.name}
            />

            <DisplayFieldData
              header='Last Name'
              value={data?.personalDetails.surname}
            />

            <DisplayFieldData
              header='Identity Number'
              value={data?.personalDetails.identityNumber}
            />

            <DisplayFieldData
              header='Gender'
              value={data?.personalDetails.gender}
            />
            <DisplayFieldData
              header='Race'
              value={data?.personalDetails.race}
            />
            <DisplayFieldData
              header='Phone Number'
              value={data?.personalDetails.phoneNumber}
            />

            <DisplayFieldData
              header='Email'
              value={data?.personalDetails.email}
            />
          </Grid>
          <Grid item xs={6}>
            {data?.address.map((address: AddressModelDto, key: React.Key) => {
              return (
                <Box mt={2} key={key}>
                  <Typography
                    sx={{ fontWeight: 'bold' }}
                    className='profile__headers'>
                    {address.addressType}
                  </Typography>
                  <Box>{address.line1}</Box>
                  <Box>{address.streetName}</Box>
                  <Box>{address.city}</Box>
                  <Box>{address.province}</Box>
                  <Box>{address.code}</Box>
                </Box>
              );
            })}
          </Grid>
        </Grid>
      )}
    </>
  );
}
